import { z } from 'zod';
import { idArray } from './shared.schema';

const accountFilterSchema = z.discriminatedUnion('type', [
	z.object({
		type: z.literal('accountId'),
		value: z.number().int(),
	}),
	z.object({
		type: z.literal('subscriptionName'),
		value: z.string(),
	}),
]);

export const outstandingBalanceReportFormatSchema = z.enum(['csv', 'pdf', 'xlsx']);

export const outstandingBalanceParametersSchema = z.object({
	accountFilter: accountFilterSchema.optional(),
	areaIds: idArray.optional(),
	asOfDate: z.iso.date(),
	branchIds: idArray.optional(),
	currentBalances: z.boolean().default(true),
	districtIds: idArray.optional(),
	facilityIds: z.array(z.string()).optional(),
	facilityName: z.string().optional(),
	facilityNumber: z.union([z.string(), z.number()]).optional(),
	format: outstandingBalanceReportFormatSchema.default('csv'),
});

export type OutstandingBalanceParameters = z.infer<typeof outstandingBalanceParametersSchema>;
export type OutstandingBalanceReportFormat = z.infer<typeof outstandingBalanceReportFormatSchema>;
